import { useState, useEffect, useRef } from "react";
import { useAppointment } from "../../../context/AppointmentContext";

const Banner = ({ specName, heading, description, backgroundImageUrl, mainImageUrl, buttons, iconData }) => {
    const [activeIcon, setActiveIcon] = useState(null);
    const containerRef = useRef(null);
    const { openAppointment } = useAppointment();

    const mappedIconData = iconData.map((icon, index) => ({
        ...icon,
        id: index + 1,
    }));

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setActiveIcon(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const renderButtons = () => (
        <div className="button-group" data-sal="slide-up" data-sal-duration="800" data-sal-delay="600">
            {buttons.map((button, index) => (
                button.text === 'Book Appointment' ? (
                    <button key={index} className="btn btn-secondary" onClick={() => openAppointment(specName)}>
                        {button.text}
                    </button>
                ) : (
                    <a key={index} href={button.link} className="btn btn-secondary">
                        {button.link.startsWith('tel:') && (
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M16.556 12.845c-1.25-.614-2.583-1.075-3.962-1.343a.75.75 0 00-.813.43l-.444 1.11a10.887 10.887 0 01-4.688-4.688l1.11-.444a.75.75 0 00.43-.813c-.268-1.38-.73-2.712-1.343-3.962a.75.75 0 00-.735-.488L4.62 3.033a.75.75 0 00-.749.613A17.935 17.935 0 0019.61 20.125a.75.75 0 00.613-.749l.38-1.495a.75.75 0 00-.488-.735z"></path>
                            </svg>
                        )}
                        {button.text}
                    </a>
                )
            ))}
        </div>
    );

    const sectionStyle = {
        backgroundImage: backgroundImageUrl
            ? `url(${process.env.REACT_APP_WEB_URL}/${backgroundImageUrl})`
            : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
    };

    return (
        <section className="gastro-care-banner specialty-banner" style={sectionStyle}>
            <div className="container">
                <div className="text-content">
                    <h1 data-sal="fade" data-sal-duration="800" data-sal-delay="200">{heading}</h1>
                    <p
                        className="footer-description"
                        data-sal="slide-up"
                        data-sal-duration="300"
                        dangerouslySetInnerHTML={{ __html: description }}
                    >
                    </p>
                    {buttons.length > 0 && renderButtons()}
                </div>

                {mappedIconData.length > 0 &&
                    <div className="image-content" ref={containerRef} data-sal="zoom-in" data-sal-duration="1000" data-sal-delay="300">
                        <div className="orbit-container">
                            <div className={`main-display ${activeIcon ? 'active' : ''}`}>
                                {activeIcon ? (
                                    <div className="icon-content fade-in">
                                        <h3>{mappedIconData.find((i) => i.id === activeIcon)?.title}</h3>
                                        <p>{mappedIconData.find((i) => i.id === activeIcon)?.description}</p>
                                    </div>
                                ) : (
                                    <img
                                        src={`${process.env.REACT_APP_WEB_URL}/${mainImageUrl}` || "https://placeholder.com/image/surgical-procedure"}
                                        alt={heading || "Surgical procedure"}
                                        className="main-image"
                                    />
                                )}
                            </div>

                            {mappedIconData.map((icon, index) => (
                                <div
                                    key={icon.id}
                                    className={`icon-wrapper icon-${index + 1} ${activeIcon === icon.id ? "active" : ""
                                        }`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setActiveIcon(icon.id);
                                    }}
                                >
                                    <img src={`${process.env.REACT_APP_WEB_URL}/${icon.img}`} alt={`icon-${icon.id}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>
        </section>
    );
};

export default Banner;